// Job estimate only: include the direct costs and overhead allocation entered.
// This is not a business-wide gross or after-tax net profit calculation.
export function calculateJobMargin({ price, labor, materials, overhead }) {
  const amount = (value, optional = false) => {
    if (value === null || value === undefined || (typeof value === 'string' && !value.trim())) {
      return optional ? 0 : null;
    }
    if (typeof value !== 'number' && typeof value !== 'string') return null;
    const number = Number(value);
    return Number.isFinite(number) && number >= 0 ? number : null;
  };
  const revenue = amount(price);
  const parts = [labor, materials, overhead].map(value => amount(value, true));
  if (revenue === null || parts.includes(null)) return null;
  const costs = parts.reduce((sum, value) => sum + value, 0);
  const profit = revenue - costs;
  const margin = revenue > 0 ? (profit / revenue) * 100 : null;
  const markup = costs > 0 ? (profit / costs) * 100 : null;
  if ([costs, profit, margin, markup].some(value => value !== null && !Number.isFinite(value))) return null;
  return { price: revenue, costs, profit, margin, markup };
}
